import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronGrabberVertical: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-grabber-vertical"} maskId="square-filled-radius-0-stroke-1-IconChevronGrabberVertical"><path fillRule="evenodd" clipRule="evenodd" d="M12.0001 4.29297L16.7072 9.00008L16.0001 9.70718L12.0001 5.70718L8.00008 9.70718L7.29297 9.00008L12.0001 4.29297ZM8.00008 14.293L12.0001 18.293L16.0001 14.293L16.7072 15.0001L12.0001 19.7072L7.29297 15.0001L8.00008 14.293Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronGrabberVertical;
